
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(25),
  playerId: Number.withConstraint(x => x >= 1),
  setLanguage: String.withConstraint(x => x.length <= 2),
  playerLanguage: String.withConstraint(x => x.length <= 5),
  event_mapping_version: Literal(2),
}).And(Partial({
  email: String.withConstraint(x => x.length <= 255),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(25),
  playerId: Number.withConstraint(x => x >= 1),
  setLanguage: String.withConstraint(x => x.length <= 2),
  playerLanguage: String.withConstraint(x => x.length <= 5),
  event_mapping_version: Literal(2),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 1 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 1 && x <= 1000),
}).And(Partial({
  email: String.withConstraint(x => x.length <= 255),
  zoneId: Number.withConstraint(x => x >= 0),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 25;
  